import { render } from "./3EntanglementInFishingGear.vue?vue&type=template&id=55d6bb6f"
import script from "./3EntanglementInFishingGear.vue?vue&type=script&lang=js"
export * from "./3EntanglementInFishingGear.vue?vue&type=script&lang=js"
script.render = render

export default script